import {list, detail, utils, shared, frame, mapio, authActions} from "@mc/mc-legacy";

/**
 * Hlavní store aplikace.
 */
const initialState = {
    [authActions.AUTH_INFO_AREA]: detail.DetailReducer(),
    signRequestList: list.SimpleListReducer(),
    qsignPracovnici: list.SimpleListReducer(),
    qsignData: list.SimpleListReducer(),
    mailTemplates: list.SimpleListReducer(),
    selectedPracovnikToFilter: detail.DetailReducer(),
    selectedPodepisujiciToFilter: detail.DetailReducer(),
    selectedRoleToFilter: detail.DetailReducer(),
    signerList: list.SimpleListReducer(),
    signConfigurationList: list.SimpleListReducer(),
    approverList: list.SimpleListReducer(),
    textNoteList: list.SimpleListReducer(),
    flowConfigurationList: list.SimpleListReducer(),
    configurationsList: list.SimpleListReducer(),
    approvalConfigurationsList: list.SimpleListReducer(),
    qsignRequestPersonList: list.SimpleListReducer(),
    mailTemplatesDetail: list.SimpleListReducer(),
    prePozadavekNevyrizeneList: list.InfiniteListReducer(),
    pozadavekNevyrizeneList: list.InfiniteListReducer(),
    podepisujiciList: list.InfiniteListReducer(),
    odmitnuteDokumentyList: list.InfiniteListReducer(),
    pozadavekVyrizeneList: list.InfiniteListReducer(),
    muNevyrizeneList: list.InfiniteListReducer(),
    keSchvaleniList: list.InfiniteListReducer(),
    historieKeSchvaleniDokumentyList: list.InfiniteListReducer(),
    prePozadavkySearchList: list.InfiniteListReducer(),
    pozadavkySearchList: list.InfiniteListReducer(),
    historieUkolDokumentyList: list.InfiniteListReducer(),
    historieDokumentyList: list.InfiniteListReducer(),
    signConnectorList: list.SimpleListReducer(),
    groupMenu: detail.DetailReducer(),
    groupMenuConfig: detail.DetailReducer(),
    logoutStatus: detail.DetailReducer(),
    overview: list.SimpleListReducer(),
    qsignPersonList: list.SimpleListReducer(),
    sealConnectorList: list.SimpleListReducer(),
    KombinaceList: list.SimpleListReducer(),
};
export default function app(state = initialState, action) {
    if (action.area) {
        return utils.processAreaStores(state, action);
    }

    return state;
}
